<template>
  <div v-if="$_get(event, 'id')" class="pa-4">
    <div class="d-flex justify-space-between">
      <Breadcrumbs
        :headline="$_get(event, 'title', 'Sự kiện')"
        :link="[{ text: 'Sự kiện', href: '../events' }, { text: 'Chi tiết sự kiện' }]"
      />
      <div class="d-flex flex-column" v-if="$auth.policies['update-event']">
        <v-btn color="primary" outlined @click="togglePublish">{{ isPublishedText }}</v-btn>
        <v-btn color="primary" outlined @click="toggleRegister" class="mt-2">{{ isOpenRegistrationText }}</v-btn>
      </div>
    </div>

    <div class="mt-6">
      <EventProfile />
      <EventTabs />
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import EventProfile from '@/modules/event/detail/EventProfile'
import EventTabs from '@/modules/event/detail/EventTabs'
export default {
  components: { Breadcrumbs, EventProfile, EventTabs },
  computed: {
    ...mapGetters({
      event: 'events/getItem',
      eventSlots: 'eventSlots/getItems'
    }),
    isPublishedText() {
      return this.event.isPublished ? 'Ngừng xuất bản' : 'Xuất bản'
    },
    isOpenRegistrationText() {
      return this.event.isOpenRegistration ? 'Đóng đăng ký' : 'Mở đăng ký'
    }
  },
  async created() {
    const eventId = this.$route.params.id
    await this.fetchOneEvent(eventId)
    await this.fetchEventSlots({ event: eventId, _sort: 'index:ASC' })
  },
  methods: {
    ...mapActions({
      fetchOneEvent: 'events/fetchOne',
      fetchEventSlots: 'eventSlots/fetchAll',
      updateEvent: 'events/update'
    }),
    togglePublish() {
      const currentIsPublished = this.event.isPublished
      let title = ''
      let text = ''
      if (currentIsPublished) {
        title = 'Xác nhận "Ngừng xuất bản"'
        text =
          'Thao tác này sẽ khiến cho sự kiện không còn hiển thị với PHHS nữa. Bạn có chắc chắn muốn thực hiện thao tác này?'
      } else {
        title = 'Xác nhận "Xuất bản"'
        text = 'Thao tác này sẽ khiến cho sự kiện hiển thị với PHHS. Bạn có chắc chắn muốn thực hiện thao tác này?'
      }
      this.$dialog.confirm({
        title,
        text,
        okText: 'Xác nhận',
        cancelText: 'Hủy',
        done: async () => {
          try {
            this.$loading.active = true
            await this.updateEvent({ id: this.event.id, isPublished: !currentIsPublished })
            this.$alert.success('Chuyển trạng thái hiển thị thành công')
          } catch (error) {
            this.$alert.error(error)
          } finally {
            this.$loading.active = false
          }
        }
      })
    },
    toggleRegister() {
      const currentIsOpenRegistration = this.event.isOpenRegistration
      let title = ''
      let text = ''
      if (currentIsOpenRegistration) {
        title = 'Xác nhận "Đóng đăng ký"'
        text =
          'Thao tác này sẽ khiến PHHS không thể đăng ký tham gia sự kiện này nữa. Bạn có chắc chắn muốn thực hiện thao tác này?'
      } else {
        title = 'Xác nhận "Mở đăng ký"'
        text =
          'Thao tác này sẽ khiến PHHS có thể đăng ký tham gia sự kiện này. Bạn có chắc chắn muốn thực hiện thao tác này?'
      }
      this.$dialog.confirm({
        title,
        text,
        okText: 'Xác nhận',
        cancelText: 'Hủy',
        done: async () => {
          try {
            this.$loading.active = true
            await this.updateEvent({ id: this.event.id, isOpenRegistration: !currentIsOpenRegistration })
            this.$alert.success('Chuyển trạng thái đăng ký thành công')
          } catch (error) {
            this.$alert.error(error)
          } finally {
            this.$loading.active = false
          }
        }
      })
    }
  }
}
</script>
